import { Reveal, Overline } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "A Visão",
    text: "O Grupo Manga nasceu com o propósito de organizar informações, estatísticas e conteúdos relacionados a plataformas e jogos, apresentando-os de forma clara, elegante e acessível.",
  },
  {
    n: "02",
    title: "O Propósito",
    text: "Reunimos indicadores e dados de maneira intuitiva, sempre com finalidade informativa — nunca como garantia de resultados.",
  },
  {
    n: "03",
    title: "O Compromisso",
    text: "Prezamos pela transparência e pelo entretenimento responsável, incentivando o uso consciente de qualquer informação disponibilizada.",
  },
];

export const NossaEmpresa = () => (
  <section className="relative py-20 md:py-32" data-testid="company-section">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <Reveal className="mb-14">
        <Overline>Institucional</Overline>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold tracking-tight uppercase text-white">
          Nossa <span className="text-gold-gradient">Empresa</span>
        </h2>
      </Reveal>

      <div className="space-y-8">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.12}>
            <div className="flex gap-5 group">
              <div className="font-display text-2xl md:text-3xl font-black text-white/10 group-hover:text-[#F5C542]/70 transition-colors duration-500 tabular-nums">
                {c.n}
              </div>
              <div className="flex-1 pb-8 border-b border-white/[0.06]">
                <h3 className="font-display text-xl md:text-2xl font-bold text-white mb-2">
                  {c.title}
                </h3>
                <p className="text-white/55 leading-relaxed font-body">
                  {c.text}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
